import React from 'react';

import { ColorsType, variables } from '../variables';

type ArrowRightSmallProps = {
  stroke?: ColorsType,
  width?: string,
  height? : string
}

export  const ArrowRightSmall: React.FC<ArrowRightSmallProps> = ({
   stroke= 'road-grey-700',
   width = '6',
   height = '9'
 }) => {
  return (
    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" stroke={variables.colors[stroke]} xmlns="http://www.w3.org/2000/svg">
      <path d="M1.59424 7.91846L5.09424 4.41846L1.59424 0.918457" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
